import type { QuestionRate } from '@/pages/analytics/types';

export type QuestionCategoryFilter = 'all' | string;

export interface QuestionCategoryTab {
  value: QuestionCategoryFilter;
  label: string;
}

const CATEGORY_ORDER = ['compliance', 'communication', 'content'];
export const EMPTY_QUESTION_CATEGORY_LABEL = '--';

export const normalizeQuestionCategory = (category: string): string =>
  category.trim().toLowerCase();

export const formatQuestionCategoryLabel = (category: string): string => {
  const normalized = normalizeQuestionCategory(category);
  if (!normalized) return EMPTY_QUESTION_CATEGORY_LABEL;

  const label = normalized.replace(/[_-]+/g, ' ');
  return `${label.charAt(0).toUpperCase()}${label.slice(1)}`;
};

const categorySortKey = (category: string): [number, string] => {
  const index = CATEGORY_ORDER.indexOf(category);
  return [index === -1 ? CATEGORY_ORDER.length : index, category];
};

export const buildQuestionCategoryTabs = (rows: QuestionRate[]): QuestionCategoryTab[] => {
  const categories = [
    ...new Set(rows.map(row => normalizeQuestionCategory(row.category)).filter(Boolean)),
  ].sort((left, right) => {
    const [leftRank, leftValue] = categorySortKey(left);
    const [rightRank, rightValue] = categorySortKey(right);
    return leftRank - rightRank || leftValue.localeCompare(rightValue);
  });

  return [
    { value: 'all', label: 'All' },
    ...categories.map(category => ({
      value: category,
      label: formatQuestionCategoryLabel(category),
    })),
  ];
};
